import {
  createFileRoute,
  type SearchSchemaInput,
} from "@tanstack/react-router";

const PAGE_TITLE = "Robinhood transfer | Glider";

export interface RobinhoodCallbackSearch {
  connectId?: string;
  error?: string;
  errorMessage?: string;
}

type RobinhoodCallbackSearchInput = SearchSchemaInput & RobinhoodCallbackSearch;

function readSearchString(value: unknown): string | undefined {
  return typeof value === "string" && value.trim() !== "" ? value : undefined;
}

/**
 * Fixed return target for the Robinhood Connect onramp flow.
 *
 * Robinhood validates the `redirectUrl` against an allowlist registered to
 * the partner `applicationId`, so this path must stay stable and registered
 * with the Robinhood Connect team for every environment (it matches the
 * legacy webapp's path). The flow opens in a new tab, so this page only
 * confirms the hand-off; the deposited balance is detected by the app's
 * normal balance polling.
 */
export const Route = createFileRoute("/onramp/robinhood/callback")({
  head: () => ({
    meta: [{ title: PAGE_TITLE }, { content: "noindex", name: "robots" }],
  }),
  validateSearch: (
    raw: RobinhoodCallbackSearchInput,
  ): RobinhoodCallbackSearch => {
    const search: RobinhoodCallbackSearch = {};
    const connectId = readSearchString(raw.connectId);
    if (connectId) {
      search.connectId = connectId;
    }
    const error = readSearchString(raw.error);
    if (error) {
      search.error = error;
    }
    const errorMessage = readSearchString(raw.errorMessage);
    if (errorMessage) {
      search.errorMessage = errorMessage;
    }
    return search;
  },
});
